import { render, staticRenderFns } from "./game-vegas.vue?vue&type=template&id=3a7f294c"
import script from "./game-vegas.vue?vue&type=script&lang=js"
export * from "./game-vegas.vue?vue&type=script&lang=js"
import style0 from "./game-vegas.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-vegas.vue
// module id = PqNW
// module chunks = 0